import React from 'react';
import './InlineTodoList.css';

function InlineTodoList({ todos }) {
    if (!todos || todos.length === 0) return null;

    const completed = todos.filter((t) => t.status === 'completed').length;
    const total = todos.length;

    return (
        <div className="inline-todo-list-sticky">
            <div className="todo-header">
                <span className="drag-icon">⋮⋮</span>
                <span className="todo-progress">
                    {completed}/{total} Tasks
                </span>
            </div>
            <div className="todo-items-container">
                {todos.map((todo, idx) => {
                    const status = todo.status === 'in-progress' ? 'in_progress' : todo.status;

                    return (
                        <div key={idx} className="inline-todo-item">
                            <span className={`todo-circle ${status}`}>
                                {status === 'completed' && <span className="checkmark">✓</span>}
                                {status === 'in_progress' && <span className="spinner"></span>}
                            </span>
                            <div className="todo-content">
                                <span className="todo-description">{todo.content || todo.description}</span>
                                {/* ✅ Show inline activity for in-progress todos */}
                                {status === 'in_progress' && todo.activity && <span className="todo-activity">💭 {todo.activity}</span>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

// ✅ Memoize to prevent re-renders when todos haven't changed
export default React.memo(InlineTodoList);
